// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// n v11.14.0  node版本
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './common/scss/index.scss'
import http from './common/js/http'
import VCharts from 'v-charts'
import router from './router'
import { setCookie, getCookie, delCookie } from './common/js/util'
import promise from 'es6-promise'
import store from './store'

import WS from '@/common/js/VueWebSocket'
Vue.prototype.$ws = WS

Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.prototype.$setCookie = setCookie
Vue.prototype.$getCookie = getCookie
Vue.prototype.$delCookie = delCookie
Vue.use(VCharts)
Vue.use(ElementUI)
promise.polyfill()
router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.requiresAuth)) {
    if (store.state.isLogin) {
      next()
    } else {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js